import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fda0c0fc"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "md:tw-p-10 tw-p-5 tw-flex tw-flex-col tw-gap-10" }
const _hoisted_2 = { class: "tw-flex tw-flex-col tw-gap-[10px] tw-font-[Poppins]" }
const _hoisted_3 = { class: "tw-font-semibold tw-text-[#211F58] tw-text-[25px] tw-leading-[100%]" }
const _hoisted_4 = { class: "tw-text-[15px] tw-font-normal tw-font-[Poppins]" }
const _hoisted_5 = { class: "tw-text-[#231F20] tw-text-[15px] tw-leading-[145%]" }
const _hoisted_6 = { class: "qr-code md:tw-flex md:tw-p-[40px] tw-p-[20px] tw-mt-[40px]" }
const _hoisted_7 = { class: "tw-flex md:tw-justify-start tw-justify-center" }
const _hoisted_8 = {
  class: "qr-code-image",
  style: {"display":"inline-block"}
}
const _hoisted_9 = ["src"]
const _hoisted_10 = { class: "qr-code-text md:tw-pl-[40px]" }
const _hoisted_11 = { class: "tw-text-[16px] tw-text-[#211F58] tw-mb-[10px] tw-font-semibold" }
const _hoisted_12 = { class: "tw-text-[#231F20] tw-text-[15px] tw-font-normal" }
const _hoisted_13 = { class: "md:tw-flex tw-justify-between tw-items-center tw-pt-[25px]" }
const _hoisted_14 = { class: "md:tw-mb-[0px] tw-mb-[15px] tw-text-[#231F20] tw-text-[14px] tw-font-medium" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tw-ml-4px tw-text-[#F7553C]" }, "*", -1))
const _hoisted_16 = { class: "md:tw-w-[520px] tw-w-[100%]" }
const _hoisted_17 = { class: "tw-flex tw-justify-between tw-items-center tw-pt-[40px]" }

import ModalHeader from "@/components/common/modalHeader.vue";
import { ref, watch } from "vue";
import ModalComponent from "@/components/common/modalComponent.vue";
import { getComponentUiText } from "@/utils/utilities";
import store from "@/store";
import CopyInfo from "@/components/common/copyInfo.vue";
import userService from "@/services/user/userService";
import { successStatusCodes } from "@/utils/constants";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { IToastMessage, ToastVariant } from "@/interfaces/common/IToastMessage";

export default /*#__PURE__*/_defineComponent({
  __name: 'addMfaTotpModal',
  props: {
  show: {
    type: Boolean,
    required: true,
  },
  profileData: {
    type: Object as () => any,
    default: () => {},
  },
  offEvent: {
    type: Boolean,
    default: false,
  },
},
  emits: ["update:show", "update:close"],
  setup(__props, { emit }) {

const props = __props;


const code = ref("");

let showRef = ref(props.show);
const handleCloseModal = () => {
  store.commit("User/setIsCloseModalProfile", true);
  showRef.value = false;
  emit("update:show", false);
  emit("update:close");
};

const showError = (message) => {
  const emitData: IToastMessage = {
    variant: ToastVariant.ERROR,
    message,
  };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};
const success = (message) => {
  const emitData: IToastMessage = {
    variant: ToastVariant.SUCCESS,
    message,
  };
  EventEmitter.emit(EmitterEvents.APP_LAYOUT_SHOW_TOAST_MESSAGE, emitData);
};
const handleUPdate = async () => {
  try {
    if (!code.value) {
      showError(
        getComponentUiText(
          "app-settings-team-members-modal-two-factor-authen-please-enter-gennerate-six-digit-1",
        ),
      );
      return;
    }
    const res: any = await userService.confirmMFAToken({ token: code.value });
    if (res.status === successStatusCodes.OK) {
      const isInternal = props.profileData?.profileData?._isInternal
        ? props.profileData.profileData._isInternal
        : props.profileData.isInternal;
      success(getComponentUiText("app-settings-add-mfa-success-message-1"));
      setTimeout(() => {
        store.commit("User/setIsCloseModalProfile", true);
        showRef.value = false;
        emit("update:show", false);
        emit("update:close");
        EventEmitter.emit(EmitterEvents.RELOAD_MANAGE_MEMBERSHIPS, isInternal);
        EventEmitter.emit(
          EmitterEvents.RELOAD_CURRENT_USER_MEMBERSHIPS,
          isInternal,
        );
      }, 1000);
    }
  } catch (error: any) {
    showError(error.data.error.message);
  }
};
const classModal = {
  background: "rgb(0, 0, 0, 0.5)",
  "border-radius": "6px",
};

const styleClassContain = {
  "border-radius": "6px",
  "box-shadow": "0px 0px 4px 0px rgba(0, 0, 0, 0.05)",
};

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createBlock(ModalComponent, {
    "model-value": _unref(showRef),
    close: handleCloseModal,
    "max-width": 62.7,
    "off-event": __props.offEvent,
    "style-class": classModal,
    "style-class-contain": styleClassContain
  }, {
    default: _withCtx(() => [
      _createVNode(ModalHeader, {
        "is-header": "",
        style: {"z-index":"10"},
        title: 
        _unref(getComponentUiText)(
          'app-settings-team-members-modal-mfa-selection-title-1',
        )
      ,
        onClose: handleCloseModal
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(getComponentUiText)(
              "app-settings-team-members-modal-two-factor-authen-change-your-2fa-1",
            )), 1),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(getComponentUiText)(
              "app-settings-team-members-modal-two-factor-authen-content-1",
            )), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("img", {
                      src: __props.profileData?.dataURL
                    }, null, 8, _hoisted_9)
                  ])
                ]),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(getComponentUiText)(
                      "app-settings-team-members-modal-two-factor-authen-code-1",
                    )), 1),
                  _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(getComponentUiText)(
                      "app-settings-team-members-modal-two-factor-authen-unable-to-scan-1",
                    )), 1),
                  _createVNode(CopyInfo, {
                    class: "tw-width-[615px] copy-info-container tw-mt-[25px] tw-px-[20px] tw-py-[10px] tw-bg-[#FFFFFF] tw-rounded-md",
                    text: __props.profileData?.tempSecret,
                    "style-icon-css": 'tw-w-[18px] tw-h-[18px]'
                  }, null, 8, ["text"])
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
                    "app-settings-team-members-modal-two-factor-authen-enter-gennerate-six-digit-to-scan-1",
                  )) + " ", 1),
                  _hoisted_15
                ]),
                _createElementVNode("div", _hoisted_16, [
                  _withDirectives(_createElementVNode("input", {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((code).value = $event)),
                    "data-cy": "add-mfa-totp-modal-code-input",
                    style: {"background":"var(--UI-rule-50, rgba(239, 240, 241, 0.5))","border":"1px","letter-spacing":"4px"},
                    type: "text",
                    class: "tw-border-[#EFF0F1] tw-rounded-md tw-py-[18px] tw-px-[20px] tw-w-[100%] tw-text-[13px] tw-font-normal tw-text-[#231F20]"
                  }, null, 512), [
                    [_vModelText, code.value]
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", null, [
                  _createVNode(_component_b_button, {
                    "data-cy": "add-mfa-totp-modal-cancel-button",
                    style: {"line-height":"90%","border":"2px solid #387dff","height":"39px"},
                    variant: "primary",
                    class: "tw-w-fit tw-shadow-none tw-bg-[#fff] tw-text-[#387DFF] tw-py-[12px] tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]",
                    type: "submit",
                    onClick: handleCloseModal
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
                      "app-menu-submenu-home-setup-wizard-modal-button-cancel-1",
                    )), 1)
                    ]),
                    _: 1
                  })
                ]),
                _createVNode(_component_b_button, {
                  "data-cy": "add-mfa-totp-modal-submit-button",
                  style: {"line-height":"90%","height":"39px"},
                  variant: "primary",
                  class: _normalizeClass(`tw-w-fit tw-shadow-none ${`tw-bg-[#387DFF]`} tw-py-[12px] tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]`),
                  type: "submit",
                  onClick: handleUPdate
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
                    "app-assessment-modal-bulk-answer-question-button-text-1",
                  )), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["model-value", "off-event"]))
}
}

})